const STATUS = {
  NOT_SUBMITTED: 'not_submitted',
  PROCESSING: 'processing',
  COMPLETE: 'complete',
  ERROR: 'error',
}

export default class FreemiumPlagiarismSubmissionStatus {
  private readonly _similarityStatus: string;
  private readonly _submissionStatus: string;
  private readonly _document: Object;
  private readonly _displayTimeExceedMessage: boolean;
  private readonly _displayGrammarCheckMessage: boolean;
  private readonly _displayAIMessage: string;
  private readonly _retrying: boolean|null;
  private readonly _aiDetectorProvider: string;

  constructor({
                submissionStatus,
                similarityStatus,
                document,
                displayTimeExceedMessage,
                displayGrammarCheckMessage,
                displayAIMessage,
                retrying,
                aiDetectorProvider
              }) {
    this._submissionStatus = submissionStatus;
    this._similarityStatus = similarityStatus;
    this._document = document;
    this._displayTimeExceedMessage = displayTimeExceedMessage;
    this._displayGrammarCheckMessage = displayGrammarCheckMessage;
    this._displayAIMessage = displayAIMessage;
    this._retrying = retrying;
    this._aiDetectorProvider = aiDetectorProvider;
  }

  get isPending(): boolean {
    return (this._submissionStatus.toLowerCase() || this._similarityStatus.toLowerCase()) === (STATUS.NOT_SUBMITTED || STATUS.PROCESSING);
  }

  get isComplete(): boolean {
    return (this._submissionStatus.toLowerCase() && this._similarityStatus.toLowerCase()) === STATUS.COMPLETE;
  }

  get failed(): boolean {
    return this._submissionStatus.toLowerCase() === STATUS.ERROR && this._retrying === false;
  }

  get document(): Object {
    return this._document;
  }

  get displayTimeExceedMessage(): boolean {
    return this._displayTimeExceedMessage;
  }

  get displayGrammarCheckMessage(): boolean {
    return this._displayGrammarCheckMessage;
  }

  get displayAIMessage(): boolean {
    return this._displayAIMessage === 'SUITABLE_FOR_API';
  }
}
